import * as React from 'react';
import { SelectItem, SelectType } from '../types';
import { SelectOption } from '../select-option';
import { OptionSelectMark, OptionDescription } from '../option';
import { SelectOptions } from '../select-options';
import { RadioSymbol, CheckSymbol } from 'ui';
import { isMultiple } from '../select-type';
import { ComplexValue } from 'ui/common/types';
import { SelectAllSection } from '../select-all-section';

import styles from './flat-options.scss';
import { OptionsPaginator } from 'ui/common/select/options-paginator';
import { LoadOptions } from 'app/types-shared';

import type { JSX } from "react";

export interface FlatOptionsProps {
  options: SelectItem[];
  valueItems: SelectItem[];
  showIcons: boolean;
  selectType?: SelectType;
  showLongDescription?: boolean;
  onSelectOption: (item: SelectItem) => void;
  onChange: (items: SelectItem[]) => void;
  showBackgroundColour?: boolean;
  leafNodeOnly?: boolean;
  allLevelsDescriptionPrefix?: string;
  returnedOptions?: ComplexValue<number>[];
  breadcrumbStack?: SelectItem[];
  breadcrumb?: React.ReactNode;
  displaySelectAll?: boolean;
  textSelectAll?: string;
  textClearAll?: string;
  textPageOf?: string;
  switchButton?: JSX.Element;
  isSearch?: boolean;
  onLoadOptions?: (loadOptions: LoadOptions) => void;
  includeDisabledCheckbox?: JSX.Element;
  uncheckSelectItem?: boolean;
}

export class FlatOptions extends React.Component<FlatOptionsProps> {

  private renderItem = (item: SelectItem, selectedValues: (string | number)[]) => {
    const { selectType, showIcons, showLongDescription, onSelectOption, showBackgroundColour } = this.props;
    const longDescriptionValue = showLongDescription && (item?.longDescription ?? '');
    const selectSymbol = isMultiple(selectType) ? <CheckSymbol /> : <RadioSymbol />;

    return <SelectOption
      key={`${item.value}_${item.description}`}
      selectType={selectType}
      hasChildren={false}
      longDescription={longDescriptionValue}>
      <OptionSelectMark selectType={selectType}
        item={item}
        onSelect={onSelectOption}
        isSelected={selectedValues.indexOf(item.value) > -1}
      />
      <OptionDescription item={item} showIcons={showIcons} selectSymbol={selectSymbol} showBackgroundColour={showBackgroundColour} />
    </SelectOption>;
  };

  public render() {
    const {
      displaySelectAll, returnedOptions, options, showLongDescription, uncheckSelectItem,
      textSelectAll, textClearAll, textPageOf, switchButton, breadcrumb, breadcrumbStack,
      valueItems = [], leafNodeOnly, allLevelsDescriptionPrefix, onChange, isSearch, includeDisabledCheckbox
    } = this.props;

    const selectAll = <SelectAllSection
      textSelectAll={textSelectAll}
      textClearAll={textClearAll}
      isRoot={breadcrumbStack?.length === 1}
      isSearch={isSearch}
      valueItems={valueItems}
      returnedOptions={returnedOptions}
      leafNodeOnly={leafNodeOnly}
      allLevelsDescriptionPrefix={allLevelsDescriptionPrefix}
      onChange={onChange} />;

    const selectedValues = !uncheckSelectItem ? valueItems.map(i => i.value) : [];
    const hasSelectAll = displaySelectAll && returnedOptions?.length > 0;
    const hasSwitchElement = !!switchButton || !!includeDisabledCheckbox;

    return (
      <>
        {breadcrumb}
        <div className="row">
          <div className={!!hasSelectAll && hasSwitchElement ? 'col-6' : 'col-12'}>
            {hasSelectAll && selectAll}
          </div>
          <div className={`${hasSwitchElement && !hasSelectAll ? 'col-12' : 'col-6 ps-0'} text-end`}>
            {!!switchButton && <div className={styles.selectSwitch}>{switchButton}</div>}
            {!!includeDisabledCheckbox && includeDisabledCheckbox}
          </div>
        </div>
        <OptionsPaginator options={options} textPageOf={textPageOf} selectedValues={selectedValues}>
          {(currentOptions) =>
            <SelectOptions showLongDescriptions={showLongDescription}>
              {currentOptions?.map(item => this.renderItem(item, selectedValues))}
            </SelectOptions>
          }
        </OptionsPaginator>
      </>
    );
  }
}
